import * as React from 'react'
import { MdCheckCircle as SuccessIcon } from '@react-icons/all-files/md/MdCheckCircle'
import { MdError as ErrorIcon } from '@react-icons/all-files/md/MdError'
export type Props = {
  type?: 'success' | 'error'
}

const DialogIcon = (props: Props): null | React.ReactNode => {
  const { type } = props
  const size = '3.5em'

  switch (type) {
    case 'success':
      return <SuccessIcon color="#32B57C" width={size} height={size} />

    case 'error':
      return <ErrorIcon color="#EB3836" width={size} height={size} />

    default:
      return null
  }
}

export default DialogIcon
